import { Injectable } from '@angular/core';
import { Observable, map, switchMap, tap } from 'rxjs';
import { ApiService } from '../core/services/api.service';
import { PrivacyPolicyModel, PrivacyPolicyStatusModel, PublishPrivacyPolicyRequest } from '../models/privacy-policy.model';

const ACCEPTED_POLICY_ID_KEY = 'privacy_policy_accepted_id';

@Injectable({
  providedIn: 'root'
})
export class PrivacyPolicyService {
  constructor(private apiService: ApiService) {}

  getCurrentPolicy(): Observable<PrivacyPolicyModel> {
    return this.apiService.get('PrivacyPolicy/current');
  }

  getMyStatus(): Observable<PrivacyPolicyStatusModel> {
    return this.apiService.get('PrivacyPolicy/my-status').pipe(
      tap(status => {
        if (status?.hasAcceptedLatest && status.currentPolicy?.privacyPolicyId) {
          localStorage.setItem(ACCEPTED_POLICY_ID_KEY, String(status.currentPolicy.privacyPolicyId));
        }
      })
    );
  }

  accept(): Observable<{ success: boolean; message: string }> {
    return this.apiService.post('PrivacyPolicy/accept', {}).pipe(
      switchMap(response => this.getMyStatus().pipe(
        map(() => response)
      ))
    );
  }

  decline(): Observable<{ success: boolean; message: string }> {
    return this.apiService.post('PrivacyPolicy/decline', {});
  }

  publish(request: PublishPrivacyPolicyRequest): Observable<PrivacyPolicyModel> {
    return this.apiService.post('PrivacyPolicy/publish', request);
  }

  clearCachedAcceptance(): void {
    localStorage.removeItem(ACCEPTED_POLICY_ID_KEY);
  }
}
